/* lua.js generated code 0.3.0 */
 //--------------------------------------------------------------------------------------
//本类由GameProxy调用进来，业务逻辑不得直接调用
//--------------------------------------------------------------------------------------
ShareProxy = xClass("ShareProxy")
QQShareProxyH5 = xClass("QQShareProxyH5", ShareProxy)
WechatgameShareProxyH5 = xClass("WechatgameShareProxyH5", ShareProxy)
var _proxy = null
ShareProxy.getInstance = function () {
    // if (!_proxy) {
    //     ShareProxy.setShareType(ShareType.WeChat)
    // }
    return _proxy
}
ShareProxy.setShareType = function (shareType) {
    _proxy = ShareProxy.create()
}
ShareProxy.setShareTypeH5 = function (shareType) {
    if (shareType === ShareType.QQ) {
        _proxy = QQShareProxyH5.create()
    } else if (shareType === ShareType.Wechatgame) {
        _proxy = WechatgameShareProxyH5.create()
    } else {
        _proxy = ShareProxy.create()
        he_log_error("not implement ios share type")
    }
}
ShareProxy.setShareTypeIOS = function (shareType) {
    if (shareType === ShareType.QQ) {
        _proxy = QQShareProxyIOS.create()
    } else if (shareType === ShareType.WeChat) {
        _proxy = WeChatShareProxyIOS.create()
    } else if (shareType === ShareType.Phone) {
        _proxy = PhoneShareProxyIOS.create()
    } else {
        _proxy = ShareProxy.create()
        he_log_error("not implement ios share type")
    }
}
ShareProxy.setShareTypeAndriod = function (shareType) {
    var aps = luajava.bindClass("com.happyelements.hellolua.aps.APSManager")
    var result = aps.getInstance().registerShare(shareType)
    if (result) {
        var shareProxy = luajava.bindClass("com.happyelements.hellolua.aps.proxy.APSShareProxy").getInstance()
        shareProxy.setShareType(shareType)
        _proxy = ShareProxyAndroid.create()
    } else {
        _proxy = ShareProxy.create()
        he_log_error("not implement android share type")
    }
}
//---------------------------------------------------------------------------------
ShareProxy.prototype.shareText = function (title, text, callback, shareScene) {
    printf("title:%s share:%s shareScene:%s", title, text, shareScene)
    callback.onSuccess()
}
//thumb 本地图片
//image 本地图片
ShareProxy.prototype.shareImage = function (title, text, thumb, image, callback, shareScene) {
    printf("shareImage:%s shareScene:%s", text, shareScene)
    printf("thumb:%s", thumb)
    printf("image:%s", image)
    callback.onSuccess()
}
//thumb 本地图片
//image 网络图片，针对网络图片会在其他线程里处理图片加载，不会卡游戏
ShareProxy.prototype.shareImageLink = function (title, text, thumb, image, callback, shareScene) {
    printf("shareImageLink:%s shareScene:%s", text, shareScene)
    printf("thumb:%s", thumb)
    printf("image:%s", image)
    callback.onSuccess()
}
ShareProxy.prototype.shareLink = function (title, text, thumb, url, callback, shareScene) {
    printf("shareLink:%s shareScene:%s", text, shareScene)
    printf("title:%s", title)
    printf("thumb:%s", thumb)
    printf("url:%s", url)
    callback.onSuccess()
}

// -------------  h5 share
QQShareProxyH5.prototype.shareText = function (textId, title, text, thumb, url, _callback, shareScene) {
    
}
QQShareProxyH5.prototype.shareImage = function (textId, title, text, thumb, url, _callback, shareScene) {
    
}
QQShareProxyH5.prototype.shareImageLink = function (textId, title, text, thumb, url, _callback, shareScene) {
    
}
// (platform, to, imgUrl, title, desc, link, callback)
// QQShareProxyH5.shareLink = function (title, text, thumb, url, callback, shareScene) {
//     type = type || QQShareType.toQQ
//     switch (type) {
//         case QQShareType.toWX:
//             QQShareProxyH5.shareToWX(onSuccess, onFail)
//             break;
//         case QQShareType.toTL:
//             QQShareProxyH5.shareToTL(onSuccess, onFail)
//             break;
//         case QQShareType.toQZ:
//             QQShareProxyH5.shareToQZ(onSuccess, onFail)
//             break;
//         case QQShareType.toQQ:
//         default:
//             QQShareProxyH5.shareToQQ(onSuccess, onFail)
//             break;
//     }
// }
QQShareProxyH5.prototype.shareLink = function (textId, title, text, thumb, url, _callback, shareScene, bg) {
    let sns = require("clover/sns/SnsProxy").getInstance()
    // let platform = UserManager.getInstance().platform
    let platform = META.platform
    // let textConfig = SentenceManager.getInstance().getRandomShareText()
    let textConfig = TextsManager.getInstance().getRandomTexts('default')
    textId = textId || textConfig.textId
    thumb = thumb || textConfig.img
    if (title) {
        if (!text) {
            text = title
            title = textConfig.title
        }
    } else {
        title = textConfig.title
        text  = textConfig.content
    }
    bg = bg || textConfig.bg
    shareScene = QQShareType[QQShareSceneMap[shareScene]] || QQShareType.toQQ
    function callback(evt) {
        let msg = evt.data && evt.data.msg || ""
        if (evt.retCode === 0) {
            if (_callback.vaildSuccess) {
                if (_callback.vaildSuccess.call(null)) {
                    _callback.onSuccess && _callback.onSuccess(evt.retCode, msg)
                } else {
                    _callback.onError && _callback.onError(1, "分享未发送")
                }
            } else {
                _callback.onSuccess && _callback.onSuccess(evt.retCode, msg)
            }
        }else if (evt.retCode === 1 || evt.retCode === -2) {
            _callback.onCancel && _callback.onCancel(evt.retCode, msg)
        }else{
            _callback.onError && _callback.onError(evt.retCode, msg)
        }
    }
 //   try {
        sns.share(textId, platform, shareScene, thumb, title, text, url, callback, bg)
    // } catch (error) {
    //     cc.error("QQShareProxyH5 error:", error);
    // }
    
}

WechatgameShareProxyH5.prototype.shareLink = function (textId, title, text, thumb, url, _callback, shareScene, bg, needRealCallback = false) {
    let sns = require("clover/sns/SnsProxy").getInstance()
    function callback(evt) {
        let msg = evt.data && evt.data.msg || ""
        if (evt.retCode === 0) {
            if (_callback.vaildSuccess) {
                if (_callback.vaildSuccess.call(null)) {
                    _callback.onSuccess && _callback.onSuccess(evt.retCode, msg, evt.data)
                } else {
                    _callback.onCancel && _callback.onCancel();
                }
            } else {
                _callback.onSuccess && _callback.onSuccess(evt.retCode, msg, evt.data)
            }            
        }else if (evt.retCode === 1 || evt.retCode === -2) {
            _callback.onCancel && _callback.onCancel(evt.retCode, msg)
        }else{
            _callback.onError && _callback.onError(evt.retCode, msg)
        }
    }

    text = text ? text : title

    let img = bg
    if (text == null || text.length == 0) {
        // let textConfig = SentenceManager.getInstance().getRandomShareText()
        let textConfig = TextsManager.getInstance().getRandomTexts('default')
        textId = textId || textConfig.textId
        // thumb = thumb || textConfig.img
        // title = title || textConfig.title
        img = bg || textConfig.bg
        text  = text  || textConfig.content
    }
   // try {
        let platform = META.platform
        sns.share(textId, platform, text, img, url, callback, needRealCallback)
    //} catch (error) {
       // cc.error("WechatgameShareProxyH5 error:", error);
        // sns.share(url, callback)
    //}
}
